// Comprehensive list of supported languages across the platform
export const ALL_LANGUAGES = [
  'English',
  'Spanish',
  'French',
  'German',
  'Chinese',
  'Japanese',
  'Portuguese',
  'Russian',
  'Arabic',
  'Hindi',
  'Italian',
  'Korean',
  'Turkish',
  'Vietnamese',
  'Polish',
  'Dutch',
  'Thai',
  'Urdu',
  'Indonesian',
  'Greek',
  'Hebrew',
  'Romanian',
  'Czech',
  'Hungarian',
  'Swedish',
  'Danish',
  'Finnish',
  'Norwegian',
  'Malay',
  'Filipino',
  'Bengali',
  'Punjabi',
  'Tamil',
  'Telugu',
  'Marathi',
  'Gujarati',
  'Kannada',
  'Malayalam',
  'Swahili',
  'Persian',
  'Ukrainian',
  'Bulgarian',
  'Croatian',
  'Serbian',
  'Slovak',
  'Slovenian',
  'Lithuanian',
  'Latvian',
  'Estonian',
  'Georgian',
  'Armenian',
  'Albanian',
  'Macedonian',
  'Bosnian',
  'Icelandic',
  'Irish',
  'Welsh',
  'Basque',
  'Catalan',
  'Galician',
  'Afrikaans',
  'Zulu',
  'Xhosa',
  'Amharic',
  'Hausa',
  'Yoruba',
  'Igbo',
  'Somali',
  'Kinyarwanda',
  'Luganda',
  'Kiswahili',
  'Nepali',
  'Sinhala',
  'Burmese',
  'Khmer',
  'Lao',
  'Mongolian',
  'Kazakh',
  'Uzbek',
  'Azerbaijani',
  'Kyrgyz',
  'Tajik',
  'Tibetan',
  'Uyghur',
  'Pashto',
  'Dari',
  'Kurdish',
  'Tamil (Sri Lanka)',
  'Tigrinya',
  'Oromo',
  'Yiddish',
  'Luxembourgish',
  'Maltese',
  'Faroese',
  'Belarusian',
  'Moldovan',
  'Farsi',
  'Sindhi',
  'Balochi',
  'Kashmiri',
  'Nepali (India)',
  'Assamese',
  'Odia',
  'Maithili',
  'Sanskrit',
  'Konkani',
  'Manipuri',
  'Bodo',
  'Dogri',
  'Santhali',
] as const;

// Famous/popular languages shown by default
export const FAMOUS_LANGUAGES = [
  'English',
  'Spanish',
  'French',
  'German',
  'Chinese',
  'Japanese',
  'Portuguese',
  'Russian',
  'Arabic',
  'Hindi',
  'Italian',
  'Korean',
  'Turkish',
  'Vietnamese',
  'Polish',
  'Dutch',
  'Thai',
  'Urdu',
  'Indonesian',
] as const;

// Keep SUPPORTED_LANGUAGES for backward compatibility (all languages)
export const SUPPORTED_LANGUAGES = ALL_LANGUAGES;

export type SupportedLanguage = typeof ALL_LANGUAGES[number];
